export default __webpack_public_path__ + "static/media/28-1.d40545a5.mp3";